import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import {Container, Accordion, Card, Button} from "react-bootstrap";
import "./payment-method.css"
import nl2br from "react-nl2br";

class PaymentMethod extends Component {
    render() {
        const {t, onContinue, backToShopLink} = this.props
        return <Container className="d-flex flex-row justify-content-center h-100">
            <div className="apay-payment-method mt-5 mb-5">
                <div className="apay-payment-method-title">
                    {t("paymentMethod.title")}
                </div>
                <Card className="rounded-5 p-2">
                    <Card.Body>
                        <Card className="mb-3 apay-card">

                            <Card.Body>
                                <Card.Title>
                                    {t("paymentMethod.byCard.title")}
                                </Card.Title>
                                <Card.Text>
                                    {t("paymentMethod.byCard.content")}
                                </Card.Text>
                                <div className="text-center">
                                    <Button className="w-100" onClick={onContinue}>
                                        {t("paymentMethod.byCard.payBtn.label")}
                                    </Button>
                                </div>

                            </Card.Body>
                        </Card>
                        <Accordion>

                            <Accordion.Item eventKey="0" className="mb-3 ">
                                <Accordion.Header>{t("paymentMethod.byKassa24.title")}</Accordion.Header>
                                <Accordion.Body>
                                    {nl2br(t("paymentMethod.byKassa24.content"))}
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>{t("paymentMethod.byYurta.title")}</Accordion.Header>
                                <Accordion.Body>
                                    {nl2br(t("paymentMethod.byYurta.content"))}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Card.Body>
                </Card>
                {backToShopLink}
            </div>
        </Container>
    }
}

export default withTranslation()(PaymentMethod)